export enum TariffType {
    Default = 0,
    InstructorsTariff = 1,
    ClubTariff = 2,
    SyntechParking = 3
}